module.exports = __webpack_public_path__ + "static/logo-hackernews-37649617c2b1ad1b98b46059a0a73422.png";